import { Input } from "./ui/input";
import TooltipInfo from "./tooltipInfo";
import imageCompression from 'browser-image-compression';

export function InputArquivo({ formik, id, label, type = "text", helpText, disabled, required }) {

  const handleFileChange = async (event) => {
    const file = event.currentTarget.files[0];

    if (!file) return;

    const isImage = file.type === 'image/jpeg' || file.type === 'image/png';

    if (isImage) {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };

      try {
        var compressedFile = await imageCompression(file, options);

        if (!(compressedFile instanceof File)) {
          compressedFile = new File([compressedFile], file.name, {
            type: file.type,
          });
        }

        formik.setFieldValue(id, compressedFile);
      } catch (error) {
        console.error('Erro ao comprimir a imagem:', error);
        formik.setFieldValue(id, file);
      }
    } else {
      formik.setFieldValue(id, file);
    }
  };

  return (
    <div className="flex flex-col gap-2 bg-white border border-border rounded-sm p-4">
      <div className="flex flex-row items-center">
        <p className="text-md font-semibold">{label}</p>
        {helpText && <TooltipInfo helpText={helpText} />}
      </div>
      <Input
        disabled={disabled}
        required={required}
        id={id}
        name={id}
        type={type}
        accept="image/png, image/jpeg, application/pdf"
        onChange={handleFileChange}
        onBlur={formik.handleBlur}
      />
      {formik.touched[id] && formik.errors[id] && <span className="text-sm text-customDanger">{formik.errors[id]}</span>}
    </div>
  )
}